import { MessageCircleMore } from "lucide-react";
import { useState } from "react";
import { askAssistant } from "../lib/api.js";

export default function Chatbot({ t }) {
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState("");

  const [messages, setMessages] = useState([
    {
      role: "assistant",
      text: "👋 Welcome to Sitaburdi Urban AI Assistant. Ask about FD rates, RD schemes, Gold Loans, Daily Collection, branches or downloads."
    }
  ]);

  async function submit(event) {
    event.preventDefault();

    if (!question.trim()) return;

    const asked = question;

    setQuestion("");

    setMessages((items) => [
      ...items,
      {
        role: "user",
        text: asked
      }
    ]);

    try {
      const response = await askAssistant(asked);

      setMessages((items) => [
        ...items,
        {
          role: "assistant",
          text: response.answer
        }
      ]);
    } catch {
      setMessages((items) => [
        ...items,
        {
          role: "assistant",
          text: "Assistant will be available once the backend service starts."
        }
      ]);
    }
  }

  return (
    <div className="fixed bottom-5 right-5 z-30 flex flex-col items-center">

      {open && (
        <div className="mb-3 flex h-[450px] w-[min(380px,calc(100vw-40px))] flex-col overflow-hidden rounded-2xl border border-[#D4AF37] bg-white shadow-2xl">

          {/* Header */}
          <div className="flex items-center justify-between bg-gradient-to-r from-[#8C4444] via-[#A05252] to-[#B76A6A] px-4 py-3 text-white">
            <div>
              <strong className="block">
                SURBANCO AI Assistant
              </strong>

              <span className="text-xs text-white/80">
                Smart Banking Support
              </span>
            </div>

            <button
              onClick={() => setOpen(false)}
              aria-label="Close assistant"
              className="text-xl font-bold hover:text-[#D4AF37]"
            >
              ×
            </button>
          </div>

          {/* Messages */}
          <div className="flex-1 space-y-3 overflow-auto bg-[#FAFAFA] p-4">
            {messages.map((message, index) => (
              <div
                key={`${message.role}-${index}`}
                className={`rounded-xl p-3 text-sm shadow-sm ${
                  message.role === "user"
                    ? "ml-8 bg-[#FFF5D6]"
                    : "mr-8 bg-white border border-[#E5E7EB]"
                }`}
              >
                {message.text}
              </div>
            ))}
          </div>

          {/* Input */}
          <form
            className="flex gap-2 border-t border-[#E5E7EB] bg-white p-3"
            onSubmit={submit}
          >
            <input
              className="focus-ring min-w-0 flex-1 rounded-xl border border-[#D1D5DB] px-3 py-2 text-sm outline-none"
              value={question}
              onChange={(event) => setQuestion(event.target.value)}
              placeholder="Ask about FD, RD, Gold Loan..."
            />

            <button
              type="submit"
              className="rounded-xl bg-gradient-to-r from-[#D4AF37] to-[#F4D675] px-4 py-2 text-sm font-black text-[#4A2E00] shadow-md transition-all hover:scale-105"
            >
              Send
            </button>
          </form>
        </div>
      )}

      {/* Floating Button */}
      <button
         className="
    flex h-16 w-16 items-center justify-center
    rounded-full
    border-2 border-[#D4AF37]
    bg-white
    shadow-xl
    transition-all
    duration-300
    hover:scale-110
    hover:shadow-[0_0_25px_rgba(212,175,55,0.45)]
  "
  onClick={() => setOpen((value) => !value)}
  title="SURBANCO AI Assistant"
>
  <img
    src="/assets/icons/chatbot.svg"
    alt="AI Assistant"
    className="h-12 w-12"
  />
      </button>
<a
  href="https://wa.me/9028089824"
   target="_blank"
  rel="noopener noreferrer"
  className="
    mt-3
    flex h-16 w-16 items-center justify-center
    rounded-full
    bg-white
    shadow-xl
    transition-all duration-300
    hover:scale-110
    hover:shadow-[0_0_20px_rgba(37,211,102,0.5)]
  "
  title="WhatsApp Us"
>
  <img
    src="/assets/icons/whatsapp.svg"
    alt="WhatsApp"
    className="h-12 w-12"
    />
</a>

    </div>
  );
}